import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { PopularTags } from "~/components/Tags/PopularTags";
import { usePrivateTags } from "~/swr-hooks/usePrivateTags";
export const PrivatePopularTags = /*#__PURE__*/ memo((param)=>{
    let { className, onTagClick } = param;
    const { data: popularTags } = usePrivateTags({
        search: "",
        sortBy: "highestCount",
        limit: 10
    });
    if (!popularTags) {
        return null;
    }
    return /*#__PURE__*/ _jsx(PopularTags, {
        className: className,
        onTagClick: onTagClick,
        tags: popularTags
    });
});
PrivatePopularTags.displayName = "PrivatePopularTags";
